import "babel-polyfill"

import promise from 'es6-promise';
promise.polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'

import store from './vuex/store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MuseUI from 'muse-ui'

import 'swiper/dist/css/swiper.css'
import 'muse-ui/dist/muse-ui.css'



import './global.css'
import './global_server.js'
import './global_router.js'
import './global_share.js'
import './global_methods.js'
import dialog from './dialogComponent.js'
import moment from 'moment/moment'

Vue.use(dialog)
Vue.use(MuseUI)
Vue.use(VueAwesomeSwiper)
Vue.filter('moment', (v, f) => moment.unix(v).format(f || 'YYYY-MM-DD HH:mm:ss'))
Vue.filter('http', v => /^(https?)/.test(v) ? v : 'http://203.160.90.202/web/' + v )

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js